import { isEmpty } from 'lodash';
import moment from 'moment';

import { Nullable, twentyFourHours } from 'types';
import { leashSettingsLocalDeliveryAndHubPassThruActive } from 'leash/utilities/systemSettings/leashSystemSettings';
import { apiContent } from 'utilities/http/api/leash/apiContent';

export const leashContentKey = 'leashContent';
export let LeashContent = JSON.parse(localStorage.getItem(leashContentKey) ?? '{}');

export const fetchLeashContent = async () => {
  const response = await apiContent.getLeashContent();
  const isLocalDeliveryAndHubPassThruActive = await leashSettingsLocalDeliveryAndHubPassThruActive();
  if (response.isOk && typeof response.json.travelPlanningContent === 'object') {
    const content = {
      ...response.json.travelPlanningContent,
      systemSettings: {
        isLocalDeliveryAndHubPassThruActive,
      },
      fetchedDate: new Date().toISOString(),
    };

    localStorage.setItem(leashContentKey, JSON.stringify(content));
  }
};

export function isLeashContentExpired() {
  const differenceBetweenFetchedDateAndNow = moment().diff(
    LeashContent.fetchedDate,
    'hours',
  );

  return twentyFourHours < differenceBetweenFetchedDateAndNow;
}

export const getLeashContentStorage = async () => {
  if (
    isEmpty(LeashContent) ||
    !localStorage.getItem(leashContentKey) ||
    isLeashContentExpired()
  ) {
    await fetchLeashContent();
    LeashContent = JSON.parse(localStorage.getItem(leashContentKey) as string);
  }
};

export const getNameOfLeashContentFieldById = (field: string, id: Nullable<number>) => {
  if (!id) return null;
  const matchingItem = LeashContent[field].find((item: { id: number; name: string }) => {
    return item.id === id;
  });

  return matchingItem?.name || null;
};

export const getIdOfLeashContentFieldByName = (field: string, name: Nullable<string>) => {
  if (!name) return null;
  const matchingItem = LeashContent[field].find((item: { id: number; name: string }) => {
    return item.name === name;
  });

  return matchingItem?.id || null;
};
